import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AppContext } from "../../../context/AppContext";

const ProtectedDoctorRoute = ({ children }) => {
  const { isTherapistLoggedIn, kycLoading } = useContext(AppContext);

  // Jab tak KYC status load ho raha hai, kuch mat dikhao
  if (kycLoading) {
    return <div style={{ padding: "40px", textAlign: "center" }}>Loading...</div>;
  }

  if (!isTherapistLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedDoctorRoute;